import { AuditService } from './baseAuditService';

export class ConsoleAuditService extends AuditService {
    protected async submitEvent(payload: string): Promise<boolean> {
        console.log(JSON.parse(payload));

        return true;
    }
}
